// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1TTjR","title":"FrontImage_title___tin5"};